import { FuncaoEquipamento } from './funcao-equipamento.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class FuncaoEquipamentoService {

    constructor(private http: Http) {
    }

    getFuncaoEquipamentos(): Observable<FuncaoEquipamento[]> {
        return this.http.get(`${NTECH_API}/funcao-equipamento`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/funcao-equipamento/funcao-equipamento.service.ts